import React from 'react';
import './ToolsSection.css';

import p1 from '../../assets/partners/img1.png';
import p2 from '../../assets/partners/img2.png';
import p3 from '../../assets/partners/img3.png';
import p4 from '../../assets/partners/img4.png';
import p5 from '../../assets/partners/img5.png';
import p6 from '../../assets/partners/img6.png';
import p7 from '../../assets/partners/img7.png';
import p8 from '../../assets/partners/img8.png';
import p9 from '../../assets/partners/img9.png';
import p10 from '../../assets/partners/img10.png';
import p11 from '../../assets/partners/img11.png';
import p12 from '../../assets/partners/img12.png';

const partners = [
    { id: 1, src: p1, alt: 'Partner 1' },
    { id: 2, src: p2, alt: 'Partner 2' },
    { id: 3, src: p3, alt: 'Partner 3' },
    { id: 4, src: p4, alt: 'Partner 4' },
    { id: 5, src: p5, alt: 'Partner 5' },
    { id: 6, src: p6, alt: 'Partner 6' },
    { id: 7, src: p7, alt: 'Partner 7' },
    { id: 8, src: p8, alt: 'Partner 8' },
    { id: 9, src: p9, alt: 'Partner 9' },
    { id: 10, src: p10, alt: 'Partner 10' },
    { id: 11, src: p11, alt: 'Partner 11' },
    { id: 12, src: p12, alt: 'Partner 12' },
];

const ToolsSection = () => {
    return (
        <section className="tools-section">

            {/* Title */}
            <h2 className="tools-title">Channel Partners</h2>

            {/* Marquee Wrapper */}
            <div className="tools-marquee">

                {/* Moving Track */}
                <div className="tools-track">

                    {/* Original Set */}
                    {partners.map((partner) => (
                        <div className="tools-logo" key={partner.id}>
                            <img src={partner.src} alt={partner.alt} />
                        </div>
                    ))}

                    {/* Duplicate Set for Infinite Scroll */}
                    {partners.map((partner) => (
                        <div className="tools-logo" key={`dup-${partner.id}`}>
                            <img src={partner.src} alt={partner.alt} />
                        </div>
                    ))}

                </div>
            </div>

        </section>
    );
};

export default ToolsSection;
